import 'bootstrap-v4-rtl/dist/js/bootstrap.bundle'

import { Link } from 'react-router-dom';
import { useGetSettingQuery } from '../../../Redux/Apis/siteApi';
import img1 from '../assets/img/enamad.png'
import Copyright from "../Components/Copyright";

function Footer() {
    const {data : {menu , contacts : { address,phone,mobile,email,socials }}} = useGetSettingQuery()
    return ( 
        <>
        <div className="footer-area">
            <div className="container">
                <div className="row">
                    <div className="col-lg-3 col-md-6">
                        <div className="footer-box about-widget">
                            <h2 className="widget-title">شبکه های اجتماعی</h2>
                            {socials && <ul className="list-unstyled">
                                {socials.map((row,index) =>
                                    <li key={index}><a href={row.value}>{row.key}</a></li>
                                )}
                            </ul>}
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="footer-box get-in-touch">
                            <h2 className="widget-title">در تماس باشید</h2>
                            <ul>
                                <li>{address}</li>
                                <li><a href={`mailto:${email}`}>{email}</a></li>
                                <li><a href={`tel:${phone}`}>{phone}</a></li>
                                <li><a href={`tel:${mobile}`}>{mobile}</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="footer-box pages">
                            <h2 className="widget-title">صفحات دیگر</h2>
                            <ul>
                                {menu && menu.map((row,index) => 
                                    <li key={index}><Link to={row.value}>{row.key}</Link></li>
                                )}
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="footer-box subscribe">
                            <h2 className="widget-title">مجوز ها</h2>
                            <p></p>
                            <img src={img1} alt='' className='img-fluid' width={200}></img>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Copyright socials={socials}/>
        </>
     );
}

export default Footer;